import axios from 'axios'

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getSubgroups(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/subgroups",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        createSubgroup(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/subgroups",
                    data: obj,
                    method: "POST"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        deleteSubgroup(obj, ids) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/subgroups/?' + `${ids.map(id=>`id=${id}`).join('&')}`,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        update(o, obj) {
            var params = {
                name: obj.name,
                idGradeGroup: obj.idGradeGroup,
                monday: obj.monday,
                tuesday: obj.tuesday,
                wednesday: obj.wednesday,
                thursday: obj.thursday,
                friday: obj.friday,
                saturday: obj.saturday,
                sunday: obj.sunday,
                start: obj.start,
                end: obj.end
            };
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/subgroups/' + obj.id,
                    data: params,
                    method: "PUT"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        async renew(o, obj) {
            
            const response = await axios({
                url: process.env.VUE_APP_URL + '/subgroups/renovate/' + obj.id,
                data: {start: obj.start, end: obj.end},
                method: "PUT"
            });

            return response;

        },
        possibleLevels(obj, params) {
            return axios({
                url: process.env.VUE_APP_URL + "/subgroups/possibleLevels",
                method: "GET",
                params: params
            });
        },
        posibleGradeGroups(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/gradegroup/web/byLevelV2?id="+params.idLevel,
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });    
            });
        },
        posibleGradeGroupsAll(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/subgroups/possibleGradeGroups",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });    
            });
        },
        getDetail(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/subgroups/" + obj.id,
                    method: "GET",
                    params: obj.params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        availableStudents(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/subgroups/availableStudents",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        addStudent(obj, data) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/subgroups/' + data.subgroup_id + '/students/' + data.student_id,
                    method: 'POST'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        deleteStudent(obj, data) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/subgroups/' + data.subgroup_id + '/students/' + data.student_id,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        notifySubgroup(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/subgroups/' + id + '/notify',
                    method: 'PUT'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            })
        },
        possibleLevels(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/subgroups/possibleLevels",
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }); 
            });
        },
    }
}